import { makeAutoObservable } from 'mobx'
import agent from '../api/agent'

export default class ExchangeCurrencyStore {
  convertedPrice: number | null = null

  constructor() {
    makeAutoObservable(this)
  }

  fetchCurrency = async (from: string, to: string, amount: number) => {
    try {
      const response = await agent.CurrencyExchange.convertCurrency(
        from,
        to,
        amount,
      )
      let convertedPrice = 0
      if (response.data && response.data.result) {
        convertedPrice = response.data.result
      }
      return convertedPrice
    } catch (error) {
      console.error(
        'An error occurred while fetching currency conversion:',
        error,
      )
    }
  }
}
